import { render } from "./business_contract.vue?vue&type=template&id=4ebcbabc&scoped=true"
import script from "./business_contract.vue?vue&type=script&lang=js"
export * from "./business_contract.vue?vue&type=script&lang=js"

import "./business_contract.vue?vue&type=style&index=0&id=4ebcbabc&scoped=true&lang=css"

import exportComponent from "E:\\daxiang\\code\\dx_project_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ebcbabc"]])

export default __exports__